import { useLanguage } from '@/app/providers';
import { CameraIcon } from '@/assets/images';
import { useWebCamera } from '@/shared/hooks/useWebCamera';
import PropTypes from 'prop-types';
import React from 'react';
import Camera, { IMAGE_TYPES } from 'react-html5-camera-photo';
import 'react-html5-camera-photo/build/css/index.css';
import './CameraCapture.scss';

export const WebCameraBase = ({ onCapture, onClose, className = '' }) => {
   const { t } = useLanguage();
   const { state, handlers, utils } = useWebCamera(onCapture, onClose);
   const { error } = state;
   const { handleTakePhoto, handleCameraError, handleCameraStart, handleCameraStop } = handlers;
   const { getErrorConfig } = utils;

   const errorConfig = getErrorConfig(error);

   if (error && errorConfig) {
      return (
         <div className={`camera-container ct-whfull ct-flexCenter ${className}`}>
            <div className="camera-popup ct-flex ct-fcol ct-flexCenter">
               <h4>{errorConfig.title || t('common.ERROR')}</h4>
               <i>
                  <CameraIcon />
               </i>
               <p>{errorConfig.message || t('user.CAMERA_ERROR')}</p>
               <div className="popup-controls ct-flex ct-jcCenter">
                  <button type="button" className="btn-okay ct-cursor" onClick={onClose}>
                     {t('common.OKAY')}
                  </button>
               </div>
            </div>
         </div>
      );
   }

   return (
      <div className={`camera-container ct-whfull ct-flex ct-fcol ${className}`}>
         <div className="camera-popup-visible ct-whfull ct-flex ct-fcol ct-relative">
            {/* Camera View */}
            <div className="cameraview captured-picture ct-flex1 ct-whfull ct-flex ct-jcCenter ct-aiCenter ct-relative">
               <Camera
                  imageType={IMAGE_TYPES.JPG}
                  isImageMirror
                  isSilentMode
                  sizeFactor={1}
                  onCameraError={handleCameraError}
                  onTakePhoto={handleTakePhoto}
                  onCameraStart={handleCameraStart}
                  onCameraStop={handleCameraStop}
                  isDisplayStartCameraError
               />
            </div>
         </div>
      </div>
   );
};

WebCameraBase.propTypes = {
   onCapture: PropTypes.func.isRequired,
   onClose: PropTypes.func.isRequired,
   className: PropTypes.string,
};

export const WebCamera = React.memo(WebCameraBase);
